import { BiTimeFive } from 'react-icons/bi';

import type { TaskResponse } from '@/store/tasks/tasks.dto';

import s from './TaskExpiringLabel.module.scss';

export const TaskExpiringLabel = ({
  task,
  extended,
}: {
  task: TaskResponse;
  extended?: boolean;
}) => (
  <p className={s.overdue} title={getDueSoonLabel(task.time_slot.end)}>
    <BiTimeFive color="#F59E0B" size={24} />
    {extended && getDueSoonLabel(task.time_slot.end)}
  </p>
);

const getDueSoonLabel = (deadline: string) => {
  const now = new Date();
  const end = new Date(deadline);

  const diffMs = end.getTime() - now.getTime();

  const minutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(minutes / 60);

  if (hours > 0) {
    return `Due in ${hours} h`;
  }

  return `Due in ${minutes} min`;
};
